import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
// 定数
var reasonColorList = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  absencePointsMap: "#3685BB"
}, "欠席-嘔吐下痢", "#775DD0"), "欠席-腹痛", "#FF4560"), "体調不良", "#33B2DF"), "infection", "#D4526E"), "コロナ関連", "#546E7A"), "37.5度以上", "#00E396");
var fiscalStart = moment([moment().subtract(3, "months").year(), 3, 1]); // momentなので月は0スタート 今回は4月を指定している

var __default__ = {
  data: function data() {
    return {
      map: {},
      popup: new mapboxgl.Popup({
        className: "popup"
      }),
      reason: "absencePointsMap",
      geoJsonData: {},
      first: true,
      markerList: [],
      lastZoomLevel: 12
    };
  },
  watch: {
    filterSchoolPointList: function filterSchoolPointList() {
      if (this.first) {
        var _this$editBounds = this.editBounds(),
          _this$editBounds2 = _slicedToArray(_this$editBounds, 2),
          bounds = _this$editBounds2[0],
          boundsPadding = _this$editBounds2[1];
        this.pointsMap(bounds, boundsPadding);
        this.first = false;
      } else {
        this.map.removeLayer("unclustered-point");
        this.map.removeLayer("unclustered-count");
        this.map.removeSource("earthquakes");
        this.editBounds();
        this.createGeoJsonData();
        this.addSource();
        this.addLayer();
      }
      this.createMarker();
    },
    reason: function reason() {
      this.map.removeLayer("unclustered-point");
      this.map.removeLayer("unclustered-count");
      this.map.removeSource("earthquakes");
      this.editBounds();
      this.createGeoJsonData();
      this.addSource();
      this.addLayer();
      this.createMarker();
    }
  },
  methods: {
    onChange: function onChange(e) {
      this.map.setStyle("mapbox://styles/mapbox/".concat(e.target.id));
    },
    onReasonChange: function onReasonChange(e) {
      this.reason = e.target.value;
    },
    pointsMap: function pointsMap(bounds, boundsPadding) {
      var _this = this;
      mapboxgl.accessToken = "pk.eyJ1Ijoic291dGFpdG8iLCJhIjoiY2t1MHQyaGxjMWhxczJ2dGh2OGJ3NGc4dCJ9.jiagpyhpWWZBJEgiqcfGyA";
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/satellite-v9",
        bounds: bounds,
        fitBoundsOptions: {
          padding: boundsPadding
        }
      });
      this.createGeoJsonData();
      this.map.on("load", function () {
        _this.addSource();
        _this.addLayer();
        _this.createMarker();
        _this.map.on("mousemove", "unclustered-point", function (e) {
          var coordinates = e.features[0].geometry.coordinates.slice();
          var school = e.features[0].properties.school;
          var schoolId = e.features[0].properties.schoolId;
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          _this.popup.setLngLat(coordinates).setHTML("<a href=\"#\" onclick=\"event.preventDefault(); Vue.router.push('/school/".concat(schoolId, "');\">").concat(school, "</a><br>").concat(e.features[0].properties.absence)).addTo(_this.map);
        });
        _this.map.on("mousemove", function (e) {
          // console.log(this.map.getZoom());
          var features = _this.map.queryRenderedFeatures(e.point)[0];
          if (features === undefined || features.source !== "earthquakes") {
            _this.popup.remove();
          }
        });
        _this.map.on("mouseenter", "unclustered-point", function () {
          _this.map.getCanvas().style.cursor = "pointer";
        });
        _this.map.on("mouseleave", "unclustered-point", function () {
          _this.map.getCanvas().style.cursor = "";
        });
        _this.map.on("style.load", function () {
          _this.addSource();
          _this.addLayer();
        });
        _this.map.on("zoom", function () {
          _this.createMarker();
        });
      });
    },
    createGeoJsonData: function createGeoJsonData() {
      var _this2 = this;
      this.geoJsonData = {
        type: "FeatureCollection",
        features: this.filterSchoolPointList.map(function (v) {
          var _v$pointMap$_this2$re;
          var filterAbsenceStr = Object.keys(v.absence).map(function (key) {
            return "&nbsp;".concat(key, ": ").concat(v.absence[key], "\u540D");
          });
          var alertText = "";
          // alert用テキスト
          if (v.pointMap["体調不良"] && v.pointMap["体調不良"] / v.student_count >= 0.1) {
            alertText += "<span style=\"color:red;\">\u2605</span>";
          }
          if (v.pointMap["欠席-嘔吐下痢"] && v.pointMap["欠席-嘔吐下痢"] / v.student_count >= 0.01) {
            alertText += "<span style=\"color:blue;\">\u2605</span>";
          }
          if (v.pointMap["infection"] && v.pointMap["infection"] / v.student_count >= 0.05) {
            alertText += "<span style=\"color:green;\">\u2605</span>";
          }
          if (v.pointMap["37.5度以上"] && v.pointMap["37.5度以上"] / v.student_count >= 0.1) {
            alertText += "<span style=\"color:yellow;\">\u2605</span>";
          }
          var count = (_v$pointMap$_this2$re = v.pointMap[_this2.reason]) !== null && _v$pointMap$_this2$re !== void 0 ? _v$pointMap$_this2$re : 0;
          // 表示位置微調整用
          var alertOffset = count < 10 ? 10 : count < 20 ? 15 : count < 50 ? 17 : 20;
          return {
            type: "Feature",
            properties: {
              count: count,
              school: v.name,
              schoolId: v.id,
              absence: "内訳<br>" + filterAbsenceStr.join("<br>"),
              alert: alertText,
              alertOffset: alertOffset
            },
            geometry: {
              type: "Point",
              coordinates: [v.longitude, v.latitude]
            }
          };
        })
      };
    },
    editBounds: function editBounds() {
      // [[w, s],[e, n]]
      var bounds = this.filterSchoolPointList.reduce(function (pre, current, i) {
        if (i === 0) {
          pre[0][0] = current.longitude;
          pre[0][1] = current.latitude;
          pre[1][0] = current.longitude;
          pre[1][1] = current.latitude;
        } else {
          pre[0][0] = pre[0][0] < current.longitude ? pre[0][0] : current.longitude;
          pre[0][1] = pre[0][1] < current.latitude ? pre[0][1] : current.latitude;
          pre[1][0] = pre[1][0] > current.longitude ? pre[1][0] : current.longitude;
          pre[1][1] = pre[1][1] > current.latitude ? pre[1][1] : current.latitude;
        }
        return pre;
      }, [[130, 34], [145, 40]]);
      var boundsPadding = {
        bottom: 30,
        top: this.isShowMenu ? 100 : 30,
        right: 30,
        left: 30
      };
      if (this.first) {
        return [bounds, boundsPadding];
      } else {
        this.map.fitBounds(bounds, {
          linear: true,
          padding: boundsPadding
        });
      }
    },
    createMarker: function createMarker() {
      if (this.markerList.length) {
        // 古いマーカーを削除
        var _iterator = _createForOfIteratorHelper(this.markerList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mark = _step.value;
            mark.remove();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      // Add markers to the map.
      var zoomCorrection = Math.pow(2, this.lastZoomLevel) / Math.pow(2, this.map.getZoom());
      this.lastZoomLevel = this.map.getZoom();
      var _iterator2 = _createForOfIteratorHelper(this.geoJsonData.features),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var marker = _step2.value;
          if (marker.properties.alert !== "") {
            // Create a DOM element for each marker.
            var el = document.createElement("div");
            // el.className = "marker";
            el.innerHTML = marker.properties.alert;
            var coordinates = this.map.project(marker.geometry.coordinates);
            var offsetcoordinates = this.map.unproject([coordinates.x + marker.properties.alertOffset * zoomCorrection, coordinates.y - marker.properties.alertOffset * zoomCorrection]);
            var _mark = new mapboxgl.Marker(el).setLngLat([offsetcoordinates.lng, offsetcoordinates.lat]).addTo(this.map);
            this.markerList.push(_mark);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    addSource: function addSource() {
      this.map.addSource("earthquakes", {
        type: "geojson",
        data: this.geoJsonData,
        cluster: false
      });
    },
    addLayer: function addLayer() {
      this.map.addLayer({
        id: "unclustered-point",
        type: "circle",
        source: "earthquakes",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": reasonColorList[this.reason],
          "circle-radius": ["step", ["get", "count"], 10, 5, 15, 10, 20, 20, 25, 50, 30],
          "circle-stroke-width": 2,
          "circle-stroke-color": "#fff"
        }
      });
      this.map.addLayer({
        id: "unclustered-count",
        type: "symbol",
        source: "earthquakes",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "text-color": "#ffffff"
        },
        layout: {
          "text-field": "{count}",
          "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
          "text-size": 12
        }
      });
    }
  }
};
import { ref, toRefs, computed, watch, inject } from "vue";
import mapboxgl from "mapbox-gl";
import moment from "moment";
import { debounce } from "throttle-debounce";
import { getData } from "@/services/axios";

import { isAuthenticatedKey, allSchoolListKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'PointsMap',
  props: {
    height: {
      type: String,
      default: "580px"
    },
    isShowMenu: {
      type: Boolean,
      default: true
    },
    activeGrade: {
      type: String,
      default: "all"
    },
    selectedDay: {
      type: String,
      default: moment().format("YYYY-MM-DD")
    },
    currentObj: {
      type: Object,
      default: moment()
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var isAuthenticated = inject(isAuthenticatedKey);
    var allSchoolList = inject(allSchoolListKey);

    // eslint-disable-next-line vue/valid-define-props

    var _toRefs = toRefs(props),
      height = _toRefs.height,
      isShowMenu = _toRefs.isShowMenu,
      activeGrade = _toRefs.activeGrade,
      selectedDay = _toRefs.selectedDay,
      currentObj = _toRefs.currentObj;
    var mapDateMaxDiff = ref(moment().diff(fiscalStart, "days"));
    var mapDateNum = ref(mapDateMaxDiff.value);
    var mapDateSelect = ref(moment(selectedDay.value));
    var mapDateFormat = ref(mapDateSelect.value.format("YYYY/MM/DD"));

    // ダッシュボード全体の日付が変更された際
    watch(function () {
      return selectedDay.value;
    }, function () {
      mapDateNum.value = moment(selectedDay.value).diff(fiscalStart, "days");
      mapDateSelect.value = moment(selectedDay.value);
    });
    var allSchoolPointList = ref([]);
    var filterSchoolPointList = computed(function () {
      return activeGrade.value === "all" ? allSchoolPointList.value.slice() : allSchoolPointList.value.filter(function (v) {
        return v.type === activeGrade.value;
      });
    });

    // apiからデータ取得
    var getPointMapData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!isAuthenticated.value) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getData("attendance_summary?pointMap=1&date=".concat(mapDateSelect.value.format("YYYY-MM-DD")));
            case 1:
              data = _context.v;
              allSchoolPointList.value = structuredClone(allSchoolList.value).map(function (v) {
                if (data.items[v.id]) {
                  v["pointMap"] = data.items[v.id]["pointMap"];
                  v["absence"] = data.items[v.id]["absence"];
                } else {
                  // 欠席者がいない場合
                  v["pointMap"] = {
                    absencePointsMap: 0,
                    "欠席-嘔吐下痢": 0,
                    "欠席-腹痛": 0,
                    体調不良: 0,
                    infection: 0,
                    コロナ関連: 0,
                    "37.5度以上": 0
                  };
                  v["absence"] = [];
                }
                return v;
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getPointMapData() {
        return _ref2.apply(this, arguments);
      };
    }();

    // authに変化があれば取得
    // authがtrueであることが分かる時点で学校情報も取得できている
    watch(isAuthenticated, function () {
      getPointMapData();
    }, {
      immediate: true
    });
    var getPointMapDataDebounce = debounce(250, getPointMapData);
    // mapのみ日付を変更した場合
    watch(mapDateNum, function () {
      mapDateSelect.value = fiscalStart.clone().add(mapDateNum.value, "days");
      mapDateFormat.value = mapDateSelect.value.format("YYYY/MM/DD");
      getPointMapDataDebounce();
    });

    // 10分ごとの再読み込み時
    watch(function () {
      return currentObj.value;
    }, function () {
      mapDateMaxDiff.value = ref(currentObj.value.diff(fiscalStart, "days"));
      getPointMapData();
    });

    // map高さのスタイル
    var mapHeight = computed(function () {
      return {
        "--map-height": height.value
      };
    });
    expose({
      isShowMenu: isShowMenu,
      filterSchoolPointList: filterSchoolPointList
    });
    return {
      __sfc: true,
      reasonColorList: reasonColorList,
      fiscalStart: fiscalStart,
      isAuthenticated: isAuthenticated,
      allSchoolList: allSchoolList,
      props: props,
      height: height,
      isShowMenu: isShowMenu,
      activeGrade: activeGrade,
      selectedDay: selectedDay,
      currentObj: currentObj,
      mapDateMaxDiff: mapDateMaxDiff,
      mapDateNum: mapDateNum,
      mapDateSelect: mapDateSelect,
      mapDateFormat: mapDateFormat,
      allSchoolPointList: allSchoolPointList,
      filterSchoolPointList: filterSchoolPointList,
      getPointMapData: getPointMapData,
      getPointMapDataDebounce: getPointMapDataDebounce,
      mapHeight: mapHeight
    };
  }
});